import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
const ReferEarnview = () => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [popup, setPopup] = useState(false);
  const [bannerPopup, setBannerPopup] = useState(false);
  const [state, setState] = useState();
  const [city, setCity] = useState();
  const [fromDate, setFormDate] = useState();
  const location = useLocation();
  const userID = location?.state?.userId?.user_id;
  const [toDate, setToDate] = useState();
  const [isReferredBy, setIsReferredBy] = useState();
  const [owners, setOwners] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState({
    from_date: "",
    to_date: "",
    search: "",
  });
  console.log("DFGHJKLFGHJKL", userID, location?.state?.userId);

  const handleStatus = ({ id }) => {
    const updatedData = [...owners];
    const currentStatus = updatedData[id].status || "on";

    updatedData[id].status = currentStatus === "on" ? "off" : "on";
    setOwners(updatedData);
    console.log("KK", id);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red"> {(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "User Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return (
            <div>
              <p>{value}</p>
              <p>{row?.original?.user_code}</p>
            </div>
          );
        },
      },

      {
        Header: "Mobile Number",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "  Amount",
        accessor: "earned",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      // {
      //   Header: "Coupon Status",
      //   accessor: "wallet_statuses",
      //   Cell: ({ value, row }) => {
      //     const ca = row.original.ca || []; // assuming 'ca' is part of your row data

      //     // Check if all elements are 3 → expired, else active
      //     const isExpired = ca.length > 0 && ca.every((v) => v === 3);

      //     return (
      //       <div>
      //         {row.original.role !== "Super Admin" && (
      //           <button
      //             className={`${
      //               isExpired ? "expired-btn" : "active-btn"
      //             } border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
      //           >
      //             {isExpired ? "Expired" : "Active"}
      //           </button>
      //         )}
      //       </div>
      //     );
      //   },
      // },
    ],
    [page]
  );

  const users = [
    { id: 1, name: "Chennai", age: 28, city: "New York" },
    { id: 2, name: "Banglore", age: 34, city: "Los Angeles" },
    { id: 3, name: "Hyderabad", age: 22, city: "Chicago" },
    { id: 4, name: "Nellore", age: 25, city: "Miami" },
    { id: 5, name: "Guntur", age: 40, city: "San Francisco" },
  ];
  const options = users.map((item) => {
    let obj = {};
    obj.value = item.name;
    obj.label = item.name;
    return obj;
  });
  const viewReferList = async () => {
    // Construct the URL with relevant query params
    const params = new URLSearchParams();
    // if (debouncedSearch) params.append("search", debouncedSearch);
    // if (selectedFilter?.from_date && selectedFilter?.to_date) {
    //   params.append("from_date", selectedFilter.from_date);
    //   params.append("to_date", selectedFilter.to_date);
    // }
    if (userID) {
      params.append("user_id", userID);
    }
    // params.append("page_size", page_size);

    const url = `${URLS.REFERUSERHISTORY}?${params.toString()}`;

    const res = await get(url);
    console.log("view property", res);
    if (res?.status === "success") {
      setPagination({ current_page: page, last_page: res?.total_pages });
      setOwners(res?.data?.referred_users);
      setIsReferredBy(res?.data?.referred_by);
    }
  };
  useEffect(() => {
    viewReferList();
  }, []);
  const handleChangeFilter = useCallback((name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
    setPage(1); // Reset to first page on filter change
  }, []);
  const handleRefferedSelect = (selected) => {
    // setOptionsList((prev) => ({ ...prev, city: selected }));
    handleChangeFilter("city", selected?.value || "");
  };
  console.log(
    "KAJDKAS",
    Object(isReferredBy),
    owners,
    owners.length + isReferredBy && 1
  );
  return (
    <div>
      <Topbar header={"Refer & Earn"} />
      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{(isReferredBy && owners.length + 1) || owners.length}
      </h2>
      {/* <div
        className="d-flex ac-js mt-3 gap-4 flex-wrap"
        style={{ width: "70%", justifyContent: "space-between" }}
      >
        <DateRange
          setFromDate={(date) => handleChangeFilter("from_date", date)}
          setToDate={(date) => handleChangeFilter("to_date", date)}
        />
        <Select
          className="location-search"
          options={options}
          value={optionsList.city}
          onChange={handleRefferedSelect}
          placeholder={"You Reffered"}
        />
      </div> */}
      <h2 className=" f3 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 mt-4 mb-3">
        Reffered By
      </h2>
      <div className="user-table " style={{ width: "70%" }}>
        <table className="w-100 border-0">
          <thead>
            <tr className=" fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3">
              <th>S.No</th>
              <th>User Name</th>
              <th>Mobile Number</th>
              <th>Refer Date</th>
            </tr>
          </thead>
          <tbody>
            <tr className="fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
              <td className="red">{isReferredBy?.name ? 1 : "-"}</td>
              <td>
                {isReferredBy?.name || "--"}
                <br />
                {isReferredBy?.user_code || "--"}{" "}
              </td>
              <td>{isReferredBy?.mobile || "--"}</td>
              <td>{isReferredBy?.joined_on || "--"}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ width: "90%" }}>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={owners}
          show={true}
        />
      </div>
    </div>
  );
};
export default ReferEarnview;
